import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import _, { get } from 'lodash'
import styled, { css } from 'styled-components'
import { Button, Modal, Checkbox } from 'antd'
import axios from 'axios'
import InfiniteScroll from 'react-infinite-scroll-component'
import { ViewIcon, SimpleUploadIcon } from '../icons' // BellIcon
import Wrapper from './wrapper'
import Banner from './comp/banner'
import Cardiometabolic from './sections/cardiometabolic'
import Aerobic from './sections/aerobic'
import MovementQuality from './sections/movementQuality'
import CognitiveHealth from './sections/cognitiveHealth'
import PageLoading from '../UI/status/loading'
import IntroductionSection from './sections/IntroductionSection'
import HealthCompassSection from './sections/HealthCompassSection'
import PersonalInfoSection from './sections/PersonalInfoSection'
import AspirationsGoalsSection from './sections/AspirationsGoalsSection'
import BoneHealth from './sections/BoneHealth'
import BodyCompResultSection from './sections/BodyCompResultSection'
import Balance from './sections/balance'
import MuscleSection from './sections/MuscleSection'
import RecommendationSectionV1 from './sections/RecommendationSectionv1'
import RecommendationSection from './sections/RecommendationSection'
import LifeStylePresentation from './LifeStylePresentation'
import Menopause from './sections/Menopause'
import { isMarketingSiteEnabled } from '../../utils/constant'
import { getClient } from '../../utils'

export default Wrapper(DraftReport)

export const DraftContainer = styled.div`
  font-family: Gilroy;
  padding-bottom: 68px;
  section {
    padding: 48px 200px;
    background: #ffffff;
    margin-bottom: 20px;
    .section-title {
      color: #4c6072;
      font-size: 32px;
      letter-spacing: 0.3px;
      text-transform: capitalize;
      line-height: 150%;
      padding: 0;
      padding-bottom: 20px;
      border-bottom: 1px solid #e3e6ea;
      font-weight: 500;
    }
    .sub-title {
      margin-top: 32px;
      margin-bottom: 16px;
      font-size: 18px;
      color: #4c6072;
      letter-spacing: 0.3px;
      text-transform: capitalize;
      display: flex;
      justify-content: space-between;
    }
  }

  /* Central branded (dark) theme. Applies the branded surface to every
     section rendered inside the report - including sections that don't
     define their own branded styles (Bone Health, Body Composition,
     Menopause, etc.) - and flips shared light elements (antd cards,
     inputs, dividers, HealthCard) to the dark palette. */
  ${(props) =>
    props.branded &&
    css`
      && section {
        background: #0a0a0a;
        color: #a3a3a3;
      }

      && .section-title {
        color: #ffffff;
        border-bottom-color: #252525;
      }

      && .sub-title {
        color: #a3a3a3;
      }

      && section .ant-divider {
        background: #252525;
      }

      /* antd cards (used by HealthCard and others) */
      && section .ant-card {
        background: transparent;
        color: #a3a3a3;
        border-color: #252525;
      }

      /* HealthCard */
      && section .health-card {
        border-color: #252525;
        header .name {
          color: #ffffff;
        }
        .ant-input {
          background-color: #161616;
          color: #a3a3a3;
        }
        .ant-card-meta-description .actions {
          border-top-color: #252525;
          color: #c5beb3;
          .btn.disabled {
            color: #6b6b6b;
          }
        }
      }
      /* HealthCard summary text: antd applies
         .ant-card-meta-description { color: rgba(0,0,0,0.45) } directly on
         the element, which is dark/invisible on the branded surface */
      && section .health-card .ant-card-meta-description,
      && section .health-card .description {
        color: #a3a3a3;
      }
      /* previous-score readout + previous-score input are #0d2350 (dark
         navy) and the "/" separator is at opacity 0.1 — all invisible on
         the dark surface */
      && section .health-card header .compare-data {
        color: #a3a3a3;
      }
      && section .health-card .meta-content .ant-input,
      && section .health-card .meta-content .ant-input:last-child {
        background-color: #161616;
        color: #a3a3a3;
      }
      && section .health-card .split {
        opacity: 0.4;
      }

      /* antd inputs / textarea */
      && section .ant-input {
        background-color: #161616;
        color: #a3a3a3;
        border-color: #252525;
      }

      /* shared range legend lists */
      && section .range-list {
        color: rgba(197, 190, 179, 0.5);
      }

      /* comment / note blocks (extraInformation) */
      && section .information-editor {
        border-color: #c5beb3;
        .mark-down-support {
          background: #161616;
          color: #a3a3a3;
          border-color: #252525;
          .direction-label,
          span {
            color: #c5beb3;
            border-bottom-color: #c5beb3;
          }
        }
      }
      && section .information-container {
        color: #c5beb3;
        border-color: #c5beb3;
        &.Opened,
        &.Sent,
        &.Locked {
          background: rgba(197, 190, 179, 0.08);
          color: #a3a3a3;
        }
        .content {
          color: #a3a3a3;
        }
        /* markdown headings inside saved notes are injected with inline
           color #383E48 — beat the inline style so they read on dark */
        .content h1,
        .content h2,
        .content h3,
        .content h4,
        .content h5,
        .content h6,
        .content strong {
          color: #e6e2da !important;
        }
        .content a {
          color: #c5beb3 !important;
        }
      }

      /* ---- low-level metric cards (LowleveMetrics) ----
         Same dark styling the blood panel (cardiometabolic) section
         applies, applied centrally so every section matches. */
      && section .section-name,
      && section .display-name {
        color: #e6e2da;
      }
      && section .bar-wrap,
      && section .tab-div,
      && section .ranges-info {
        background: #141414;
        border-color: #2a2a2a;
      }
      && section .tab-background {
        background: #141414;
      }
      && section .range-title,
      && section .range-level {
        color: #e6e2da;
      }
      && section .range-info-container {
        color: #a3a3a3;
      }
      && section .progress-container {
        background: transparent;
      }
      && section .range-info .name {
        color: #a3a3a3;
        opacity: 1;
      }
      && section .ant-tabs-tab-btn {
        color: #a3a3a3;
      }
      && section .ant-tabs-tab-active .ant-tabs-tab-btn {
        color: #c5beb3;
      }
      && section .ant-tabs-ink-bar {
        background: #c5beb3;
      }
      && section .tab-scroll,
      && section .tab-scroll p,
      && section .tab-scroll li,
      && section .tab-scroll div {
        color: #a3a3a3;
      }

      /* ---- body composition score items (metric titles above range bars
         + metric value rows) — same label/value colors as the blood panel ---- */
      && section .score-item {
        color: #e6e2da;
        border-bottom-color: #252525;
      }
      && section .score-item .h-item {
        color: #e6e2da;
      }
      /* Previous / Age-Ranking / Desired captions */
      && section .score-item .r-item {
        color: #a3a3a3;
      }
      /* big metric numbers that don't carry a green/red status class */
      && section .score-item .value:not(.green):not(.red) {
        color: #c5beb3;
      }

      /* ---- shared RangeBar texts (body comp, bone health DXA, muscle,
         balance, aerobic) ----
         .range-area and the value numbers carry inline #4c6072, so they
         need !important to override */
      && section .range-area {
        color: #e6e2da !important;
      }
      && section .range-item .value span,
      && section .range-item .value-number {
        color: #e6e2da !important;
      }
      /* level caption sitting on the range strip (has-value .level) */
      && section .range-item .has-value .level {
        color: #e6e2da;
      }

      /* muscle fitness sub-section names */
      && section .metrics-section-name {
        color: #e6e2da;
      }

      /* strength/muscle bar charts shared legend + value rows.
         StrengthContainer's .range-list / .metric-info rules beat the generic
         section rules on specificity, so re-assert them here. */
      && section .range-list {
        color: rgba(197, 190, 179, 0.6);
      }
      && section .metric-info {
        color: #a3a3a3;
      }
      && section .metric-info .currently {
        color: #e6e2da;
      }
      /* (L) / (R) / TOTAL / (AVG) labels next to the compare bars */
      && section .bar-with-title > span {
        color: #a3a3a3;
      }
      /* muscle metric titles: Grip Strength (L)/(R), single-text titles,
         body-chart titles + fallback values (no status color).
         The base rules are deeply nested (up to 0,7,0), so these use the
         full path to win. Status colors (green/red inline) are untouched. */
      && section .metric-content .metric-middle-container .sub-metrics-container .metric-text-container .single-text-metric .single-text-metric-title,
      && section .metric-middle-container .sub-metrics-container .metric-text-container .single-text-metric .single-text-metric-title,
      && section .single-text-metric-title {
        color: #e6e2da;
      }
      && section .metric-name,
      && section .body-chart-metric-title,
      && section .polar-chart-name {
        color: #e6e2da;
      }
      /* movement-quality / body-comp RangeBar names, e.g.
         "Cervical Lateral Flexion Right" — RangeBarContainer's
         "color: #4c6072" is inherited (no direct color on .name) */
      && section .ranges .name,
      && section .ranges .name span {
        color: #e6e2da;
      }

      /* ---- illustrations: monochrome blue line-art figures
         (skeleton / exercise movement poses, body diagrams, menopause
         figure) → white line-art on the dark surface.
         Targeted containers only — never invert uploads / DXA scans ---- */
      && section .metric-image-conatiner img,
      && section .balance-layout .image > img,
      && section .image-container img,
      && section .image-around img,
      && section .female-sprint-img {
        filter: brightness(0) invert(1);
        opacity: 0.8;
      }
      /* ---- branded (marketing-site) view: SVG files in /branded/
         already have white stroke paths, so don't re-invert them ---- */
      && section .metric-image-conatiner img[src*="/branded/"],
      && section .balance-layout .image > img[src*="/branded/"],
      && section .image-container img[src*="/branded/"],
      && section .image-around img[src*="/branded/"],
      && section .female-sprint-img[src*="/branded/"] {
        filter: none;
        opacity: 1;
      }

      /* body-composition figure labels (Right Arm % Fat, Trunk % Fat,
         Left Leg % Fat, etc.) and their values — inherited dark
         #4c6072 is unreadable on the dark surface */
      && section .image-around .label,
      && section .image-around .level {
        color: #e6e2da;
      }

      /* victory chart labels (muscle history chart) are inline-styled
         #4C6072 — override with !important */
      && section .metric-middle-container svg text {
        fill: #a3a3a3 !important;
      }

      /* menopause score headers + chart tooltips */
      && section .score-header {
        color: #a3a3a3;
      }
      && section .custom-tooltip,
      && section .custom-tooltip-container {
        background: #161616;
        color: #a3a3a3;
        border: 1px solid #252525;
      }

      /* Exercise Scheduler modal - dark overlay + content */
      && .exercise-scheduler-modal-branded .ant-modal-content {
        background-color: #0d0d0d;
        border: 1px solid #252525;
        border-radius: 12px;
      }
      && .exercise-scheduler-modal-branded .ant-modal-body {
        background-color: #0d0d0d;
        padding: 0;
      }
      && .exercise-scheduler-modal-branded .ant-modal-close {
        color: #e6e2da;
      }
      && .exercise-scheduler-modal-branded .ant-modal-close:hover {
        color: #ffffff;
        background-color: #252525;
      }
    `}
`

const ErrorContainer = styled.div`
  display: flex;
  margin-top: 112px;
  font-size: 18px;
  font-family: Gilroy;
  color: #323f4a;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  .message {
    margin-bottom: 8px;
  }
`

export const Footer = styled.footer`
  width: 1440px;
  max-width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 17px 200px;
  position: fixed;
  bottom: 0;
  background: #fcfdfd;
  box-shadow: 0px -10px 10px rgba(51, 41, 41, 0.05);
  div > button {
    margin-left: 10px;
  }
  div > button:first-child {
    margin-left: 0;
  }

  ${(props) =>
    props.branded &&
    css`
      background: #0a0a0a;
      box-shadow: 0px -10px 10px rgba(0, 0, 0, 0.4);

      div > button {
        border-color: #c5beb3;
        color: #c5beb3;
        &:hover,
        &:focus {
          border-color: #ffffff;
          color: #ffffff;
        }
      }

      div > button.ant-btn-primary:not(.ant-btn-ghost) {
        background: #ffffff;
        border-color: #ffffff;
        color: #0a0a0a;
      }
    `}
`

function DraftReport(props) {
  const {
    list,
    person,
    loginRole,
    arDetail,
    latest_bmi,
    latest_height,
    latest_weight,
    device_info,
    residence,
    dynamicData,
    handlePublish,
    handlePreview,
    handleSave,
    showActivity,
    // handleNotify,
    handleCommendSave,
    HandleSaveScore,
    updateEditingCount,
    editingCount,
    createdFailed,
    ageScopes,
    infinityLoadCount,
    maxLoadCount,
    next,
    hideSectionHandle,
    hideSection,
    trendMetrics,
    onUpdateReferral,
    updateArDetail,
    exerciseRecommendationPlots,
    copilotDashboard,
    executiveSummary,
    useAspirationAndGoals,
    useAIRecommendations
  } = props

  const previous = get(dynamicData, 'healthSpanDomainSummary.1', {})
  const latest = get(dynamicData, 'healthSpanDomainSummary.0', {})
  const hasMore = infinityLoadCount < maxLoadCount
  const branded = isMarketingSiteEnabled(person)
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const clientGender = get(getClient(), 'profile.gender', '')
 
  const getDataList = (snapshot, graph_type) => {
    return list.map((item) => {
      // const catchScore = catchEditScore.find(
      //   (score) => score.type === item.type && score.graph_type === graph_type
      // )
      const detail =
        (snapshot[item.type] && _.cloneDeep(snapshot[item.type])) || {}
      detail.isDefaultValue = true
      if (detail.score_manual && detail.score_manual.value) {
        detail.isDefaultValue = false
      }
      // if (catchScore) {
      //   detail.score_manual = Object.assign(detail.score_manual || {}, {
      //     value: catchScore.score,
      //     updated_at: new Date()
      //   })
      // }
      return {
        ...item,
        ...detail
      }
    })
  }

  const compareData = getDataList(previous.snapshot || {}, 'previous')
  const dataList = getDataList(latest.snapshot || {}, 'latest')

  let [catchEditScore, setCatchEditScore] = useState([])
  const [scoresLegalCheck, serScoresLegalCheck] = useState({})

  const saveBulk = async (catchData) => {
    await HandleSaveScore(catchData || catchEditScore)
    setCatchEditScore([])
  }

  const save = async (type, setToDefaultValue) => {
    if (setToDefaultValue) {
      await saveBulk([
        {
          type,
          score: null,
          graph_type: 'latest'
        },
        {
          type,
          score: null,
          graph_type: 'previous'
        }
      ])
    } else if (catchEditScore.length) {
      await saveBulk()
    }
  }
  const onScoreChangeHandle = (score, type, graph_type) => {
    score = score || null
    let targetIndex = catchEditScore.findIndex(
      (item) => item.type === type && item.graph_type === graph_type
    )
    const scoreLegal = score ? score >= 5 && score <= 99 : true
    const scoreKey = type + graph_type
    scoresLegalCheck[scoreKey] = scoreLegal

    if (targetIndex !== -1) {
      catchEditScore[targetIndex].score = score
    } else {
      catchEditScore.push({
        type,
        graph_type,
        score
      })
    }
    setCatchEditScore(catchEditScore)
    serScoresLegalCheck(scoresLegalCheck)
  }
  const cancelEdit = (type) => {
    if (type) {
      catchEditScore = catchEditScore.filter((item) => item.type !== type)
      setCatchEditScore(catchEditScore)
    } else {
      setCatchEditScore([])
    }
  }

  const commonProps = {
    hideSectionHandle,
    hideSection,
    person,
    dynamicData,
    onScoreChangeHandle,
    cancelEdit,
    updateEditingCount,
    loginRole,
    handleCommendSave,
    arDetail,
    view: 'Draft'
  }

  return arDetail ? (
    <InfiniteScroll
      dataLength={infinityLoadCount}
      next={next}
      hasMore={infinityLoadCount < maxLoadCount}
      loader={
        <h4
          style={{
            paddingBottom: 75,
            fontSize: 24,
            textAlign: 'center',
            color: branded ? '#a3a3a3' : '#4C6072'
          }}
        >
          Loading...
        </h4>
      }
      endMessage={
        <p style={{ textAlign: 'center', color: branded ? '#a3a3a3' : undefined }}>
          <b>Yay! You have seen it all</b>
        </p>
      }
    >
      <DraftContainer branded={branded}>
        <Banner person={person} period={arDetail.time_period} />
        <IntroductionSection
          {...commonProps}
          notes={arDetail.notes}
          handleCommendSave={handleCommendSave}
          editabled
        />
        <PersonalInfoSection
          {...{
            person,
            latest_bmi,
            latest_height,
            latest_weight,
            device_info,
            residence
          }}
        />
        {useAspirationAndGoals && <AspirationsGoalsSection {...commonProps} />}
        <HealthCompassSection
          {...commonProps}
          {...{
            compareData,
            dataList,
            person,
            dynamicData
          }}
        />
        {clientGender === 'female' && (
          <Menopause
            {...commonProps}
            {...{
              compareData,
              dataList,
              person,
              dynamicData
            }}
          />
        )}
        {infinityLoadCount > 1 && (
          <Cardiometabolic
            {...commonProps}
            {...{
              previous,
              latest,
              save,
              handleSave,
              trendMetrics,
              useAspirationAndGoals
            }}
          />
        )}

        {infinityLoadCount > 2 && (
          <>
            <BoneHealth
              {...commonProps}
              {...{
                ageScopes,
                compareData,
                dataList,
                save,
                handleSave,
                infinityLoadCount
              }}
            />
            <BodyCompResultSection
              {...commonProps}
              {...{
                ageScopes,
                compareData,
                dataList,
                save,
                handleSave,
                infinityLoadCount
              }}
            />
          </>
        )}

        {infinityLoadCount > 3 && (
          <CognitiveHealth
            {...commonProps}
            {...{
              save,
              dataList,
              compareData,
              ageScopes
            }}
          />
        )}

        {infinityLoadCount > 4 && (
          <Balance
            {...commonProps}
            {...{
              ageScopes,
              compareData,
              dataList,
              save,
              handleSave,
              infinityLoadCount
            }}
          />
        )}

        {infinityLoadCount > 5 && (
          <>
            <MovementQuality
              {...commonProps}
              {...{
                ageScopes,
                compareData,
                dataList,
                save,
                handleSave
              }}
            />
          </>
        )}

        {infinityLoadCount > 6 && (
          <>
            <MuscleSection
              {...commonProps}
              {...{
                ageScopes,
                compareData,
                dataList,
                save,
                handleSave
              }}
            />
          </>
        )}

        {infinityLoadCount > 7 && (
          <Aerobic
            {...commonProps}
            {...{
              ageScopes,
              compareData,
              dataList,
              save,
              handleSave,
              infinityLoadCount
            }}
          />
        )}

        {!hasMore && (
          <>
            {useAIRecommendations ? (
              <>
                <LifeStylePresentation
                  {...commonProps}
                  arDetail={arDetail}
                  person={person}
                  lsd={_.get(dynamicData, 'lifeStyleSummary', {})}
                  editabled={true}
                  handleCommendSave={handleCommendSave}
                />
                <RecommendationSection
                  {...commonProps}
                  person={person}
                  lsd={_.get(dynamicData, 'lifeStyleSummary', {})}
                  hsd={_.get(dynamicData, 'healthSpanDomainSummary', {})}
                  editabled={true}
                  arDetail={arDetail}
                  onUpdateNotes={handleCommendSave}
                  onUpdateReferral={onUpdateReferral}
                  updateArDetail={updateArDetail}
                  exerciseRecommendationPlots={exerciseRecommendationPlots}
                  copilotDashboard={copilotDashboard}
                  useAspirationAndGoals={useAspirationAndGoals}
                  executiveSummary={executiveSummary}
                />
              </>
            ) : (
              <RecommendationSectionV1
                {...commonProps}
                editabled={true}
                arDetail={arDetail}
                onUpdateNotes={handleCommendSave}
                onUpdateReferral={onUpdateReferral}
                updateArDetail={updateArDetail}
                useAspirationAndGoals={useAspirationAndGoals}
              />
            )}
          </>
        )}

        <Footer branded={branded}>
          <div>
            <Button
              ghost
              type="primary"
              onClick={() => handleSave()}
              disabled={editingCount > 0}
            >
              SAVE AS DRAFT
            </Button>
            <Button
              ghost
              type="primary"
              disabled={editingCount > 0}
              onClick={() => showActivity()}
            >
              ACTIVITY
            </Button>
          </div>
          <div>
            <Button
              ghost
              type="primary"
              onClick={handlePreview}
              disabled={editingCount > 0}
            >
              <ViewIcon />
              PREVIEW
            </Button>
            <Button
              type="primary"
              onClick={handlePublish}
              disabled={editingCount > 0}
            >
              <SimpleUploadIcon />
              PUBLISH
            </Button>
            {/* <Button
            type="primary"
            onClick={handleNotify}
            disabled={!arDetail.published_at}
          >
            <BellIcon />
            NOTIFY CLIENT
          </Button> */}
          </div>
        </Footer>
      </DraftContainer>
    </InfiniteScroll>
  ) : createdFailed ? (
    <ErrorContainer>
      <span className="message">{createdFailed}</span>
      <Button
        type="primary"
        onClick={() => {
          props.history.goBack()
        }}
      >
        Back
      </Button>
    </ErrorContainer>
  ) : (
    <PageLoading />
  )
}
